var map = {
	"./beforeAfter.json": [
		701,
		701
	],
	"./gallery.json": [
		908,
		908
	],
	"./plans.json": [
		386,
		386
	],
	"./schemes.json": [
		498,
		498
	],
	"./villagers.json": [
		193,
		193
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 126;
module.exports = webpackAsyncContext;